import { config } from 'utils/config'

export const urlWithHost = (path: string) => {
  switch (config.apiEnv) {
    case 'development':
      return `http://localhost:3000${path}`
    case 'staging':
      return `https://staging.thingtesting.com${path}`
    default:
      return `https://thingtesting.com${path}`
  }
}

export const apiUrl = (path: string) => {
  switch (config.apiEnv) {
    case 'development':
      return `http://localhost:4000${path}`
    case 'staging':
      return `https://staging-api.thingtesting.com${path}`
    default:
      return `https://api.thingtesting.com${path}`
  }
}

export const outboundLinkUrl = (path: string) => {
  switch (config.apiEnv) {
    case 'development':
      return `http://localhost:4002${path}`
    default:
      return `https://click.thingtesting.com${path}`
  }
}
